<button *ngIf="openModalButtonVisible" class="btn btn-primary" (click)="openForNew()">+ ADD LICENSES</button>

<ng-template #modal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ isEditMode ? 'Edit Licenses' : 'Add Licenses' }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row mt-1 mb-4" *ngIf="license.PurchasingOrganizationDescription">
      <div class="col-12">
        <h5 class="text-muted mb-0">Organization: {{ license.PurchasingOrganizationDescription }}</h5>
        <small class="text-muted" *ngIf="isEditMode && license.PurchasedLicensesID">
            Purchased Licenses ID: {{ license.PurchasedLicensesID }}
        </small>
      </div>
    </div>
    <form>
      <div class="row">
        <!-- Input Fields Column -->
        <div class="col-md-6">
          <div class="form-group">
            <label for="quantity">Quantity *</label>
            <input type="text" class="form-control" id="quantity" 
                   [(ngModel)]="formattedQuantity" name="quantity" 
                   placeholder="Enter quantity">
          </div>

          <div class="form-group">
            <label for="purchaseAmount">Purchase Amount *</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">$</span>
              </div>
              <input type="text" class="form-control" id="purchaseAmount" 
                     [(ngModel)]="formattedPurchaseAmount" name="purchaseAmount" 
                     placeholder="Enter amount">
            </div>
          </div>

          <div class="form-group">
            <label for="purchaseDate">Purchase Date *</label>
            <app-datepicker [(model)]="license.PurchaseDate" (modelChange)="onPurchaseDateChange()"></app-datepicker>
          </div>

          <div class="form-group">
            <label for="licenseStartDate">License Start Date *</label>
            <app-datepicker [(model)]="license.LicenseStartDate" (modelChange)="onLicenseStartDateChange()"></app-datepicker>
          </div>

          <div class="form-group">
            <label for="licenseEndDate">License End Date *</label>
            <app-datepicker [(model)]="license.LicenseEndDate"></app-datepicker>
          </div>

          <div class="form-group">
            <label for="purchaseType">Purchase Type *</label>
            <select class="form-control" id="purchaseType" 
                    [(ngModel)]="license.LicensePurchaseType" name="purchaseType" required>
              <option value="">Select Purchase Type</option>
              <option value="Individual">Individual</option>
              <option value="IndividualSTH">Individual - STH</option>
              <option value="SiteLicense">Site License</option>
              <option value="SiteLicenseSTH">Site License - STH</option>
              <option value="Class">Class</option>
              <option value="BundleOf50">Bundle of 50</option>
              <option value="JoyForAllIndividual">Joy For All Individual</option>
              <option value="JoyForAllVillage">Joy For All Village</option>
            </select>
          </div>

          <div class="form-group">
            <label for="purchaseLevel">Purchase Level *</label>
            <select class="form-control" id="purchaseLevel" 
                    [(ngModel)]="license.PurchaseLevel" name="purchaseLevel" required>
              <option value="">Select Purchase Level</option>
              <option value="School">School</option>
              <option value="District">District</option>
              <option value="State">State</option>
              <option value="DistributionPartner">Distribution Partner</option>
              <option value="Donor">Donor</option>
            </select>
          </div>

          <div class="form-group">
            <label for="purchaseOrderId">Purchase Order ID</label>
            <input type="text" class="form-control" id="purchaseOrderId" 
                   [(ngModel)]="license.PurchaseOrderID" name="purchaseOrderId" 
                   placeholder="Enter purchase order ID (optional)">
          </div>

          <div class="form-group">
            <label for="dealId">Deal ID</label>
            <input type="text" class="form-control" id="dealId" 
                   [(ngModel)]="license.DealID" name="dealId" 
                   placeholder="Enter deal ID (optional)">
          </div>

          <div class="form-group">
            <label for="invoiceId">Invoice ID</label>
            <input type="text" class="form-control" id="invoiceId" 
                   [(ngModel)]="license.InvoiceID" name="invoiceId" 
                   placeholder="Enter invoice ID (optional)">
          </div>

          <div class="form-group">
            <label for="note">Note</label>
            <textarea class="form-control" id="note" 
                      [(ngModel)]="license.Note" name="note" 
                      placeholder="Enter notes (optional)"
                      maxlength="400"
                      rows="3"></textarea>
            <small class="form-text text-muted">
              {{ (license.Note?.length || 0) }}/400 characters
            </small>
          </div>

          <!-- Renewed Purchases Section -->
          <div *ngIf="allLicenses && allLicenses.length > 0; else loadingRenewalInfo" class="form-group">
            <label>Licenses Renewed by This Purchase</label>
            
            <!-- Display current renewed purchases -->
            <div *ngIf="license.PurchasesRenewedByThisPurchase && license.PurchasesRenewedByThisPurchase.length > 0" 
                 class="renewed-purchases-list mb-3">
              <div *ngFor="let renewedPurchase of license.PurchasesRenewedByThisPurchase; let i = index" 
                   class="renewed-purchase-item d-flex justify-content-between align-items-center p-2 border rounded mb-2">
                <div class="flex-grow-1">
                  <small class="text-muted">{{ getLicenseDisplayInfo(renewedPurchase.PurchasedLicensesID) }}</small>
                </div>
                <button type="button" 
                        class="btn btn-sm btn-outline-danger ml-2" 
                        (click)="removeRenewedPurchase(i)"
                        title="Remove">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            
            <div *ngIf="!license.PurchasesRenewedByThisPurchase || license.PurchasesRenewedByThisPurchase.length === 0" 
                 class="text-muted small mb-3">
              No licenses are currently set to be renewed by this purchase.
            </div>
            
            <!-- Add new renewed license dropdown -->
            <div class="input-group mb-2">
              <select class="form-control" 
                      [(ngModel)]="selectedRenewableLicenseId" 
                      name="renewedLicense"
                      [disabled]="!allLicenses || allLicenses.length === 0 || getRenewableLicensesForDropdown().length === 0">
                <option value="">Select a license to add...</option>
                <option *ngFor="let license of getRenewableLicensesForDropdown()" 
                        [value]="license.PurchasedLicensesID">
                  {{ license.PurchasingOrganizationDescription }} - {{ license.PurchaseDate | date }} - ${{ license.PurchaseDollarAmount?.toLocaleString() }}
                </option>
              </select>
              <div class="input-group-append">
                <button type="button" 
                        class="btn btn-outline-primary" 
                        (click)="addRenewedPurchase()"
                        [disabled]="!selectedRenewableLicenseId">
                  <i class="fas fa-plus"></i> Add
                </button>
              </div>
            </div>
            
            <small class="form-text text-muted">
              Select licenses that will be renewed by this purchase. Only the license IDs will be stored.
            </small>
          </div>
          
          <!-- Loading template for renewal info -->
          <ng-template #loadingRenewalInfo>
            <div class="form-group">
              <app-loading-spinner [text]="'Loading Renewal Info'"></app-loading-spinner>
            </div>
          </ng-template>
        </div>

        <!-- Read-only Calculated Fields Column -->
        <div class="col-md-6 d-flex align-items-center">
          <div class="alert alert-info w-100">
            <div class="form-group">
              <label>License Length:</label>
              <div class="form-control-plaintext">
                <strong>
                  <span *ngIf="license.LicenseStartDate && license.LicenseEndDate">
                    {{ calculateLicenseLength() }} years
                  </span>
                  <span *ngIf="!license.LicenseStartDate || !license.LicenseEndDate">-</span>
                </strong>
              </div>
            </div>

            <div class="form-group">
              <label>ARR:</label>
              <div class="form-control-plaintext">
                <strong>
                  <span *ngIf="license.PurchaseDollarAmount && calculateLicenseLength() > 0">
                    ${{ calculateARR() | number:'1.2-2' }}
                  </span>
                  <span *ngIf="!license.PurchaseDollarAmount || calculateLicenseLength() <= 0">-</span>
                </strong>
              </div>
            </div>

            <div class="form-group">
              <label>Cost Per License:</label>
              <div class="form-control-plaintext">
                <strong>
                  <span *ngIf="calculateARR() > 0 && license.Quantity">
                    ${{ calculateCostPerLicense() | number:'1.2-2' }}
                  </span>
                  <span *ngIf="calculateARR() <= 0 || !license.Quantity">-</span>
                </strong>
              </div>
            </div>

            <div class="form-group" *ngIf="license.PurchaseOrderID">
              <label>Purchase Order ID:</label>
              <div class="form-control-plaintext">
                <strong>{{ license.PurchaseOrderID }}</strong>
              </div>
            </div>

            <div class="form-group" *ngIf="license.DealID">
              <label>Deal ID:</label>
              <div class="form-control-plaintext">
                <strong>{{ license.DealID }}</strong>
              </div>
            </div>

            <div class="form-group" *ngIf="license.InvoiceID">
              <label>Invoice ID:</label>
              <div class="form-control-plaintext">
                <strong>{{ license.InvoiceID }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving || !isFormValid()">
      <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
      {{ saving ? 'Saving...' : (isEditMode ? 'Update' : 'Save') }}
    </button>
  </div>
</ng-template> 